<template>
  <div class="panel panel-default">
    <slot/>
  </div>
</template>

<script>
export default {
  name: "collapse"
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Collapse/Collapse.vue